<template lang="pug">
v-menu(offset-y)
    template(v-slot:activator="{on}")
        v-btn.language-button.mb-1(text v-on="{...on}")
            v-icon fal fa-globe
            span.ml-1.mr-1 {{ getLanguageLabel(currentLanguage.code) }}

    v-list
        v-list-item(
            v-for="(language, idx) in supportedLanguages" :key="idx"
            @click="onLanguageSelect(language)"
        )
            | {{ language.label }}

</template>

<script lang="ts">
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { CURRENT_UI_LANGUAGE, SUPPORTED_LANGUAGES } from '@/store/getter-types'
import { SWITCH_APPLICATION_LANGUAGE } from '@/store/action-types'
import Language from '@/model/Language';

@Component
export default class LanguageSelectionButton extends Vue {
    $refs!: {
        activatorButton: Vue
    }

    @Getter(SUPPORTED_LANGUAGES) supportedLanguages!: Language[]
    @Getter(CURRENT_UI_LANGUAGE) currentLanguage!: Language

    @Action(SWITCH_APPLICATION_LANGUAGE) switchApplicationLanguage!: { (payload: Language): void }

    get activator (): Vue {
        return this.$refs.activatorButton
    }

    getLanguageLabel (language: string) {
        if(language === 'sk') {
            return 'SK'
        } else if (language === 'cs') {
            return 'CZ'
        }
    }

    onLanguageSelect (language: Language): void {
        this.switchApplicationLanguage(language)
        localStorage.setItem('uiLanguageCodeApp', language.code)
    }
    mounted () {
    }
}
</script>

<style lang="stylus" scoped>
.language-button
  font-size: x-small !important
  font-weight: bold !important
  text-transform: none
</style>